import { Box, Stack, Typography } from "@mui/material";
import { BankImage } from "Components/Shared/BankImage";
import type { Bank } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";
import { getLocalBankAccountNumberFromIBAN } from "Utils/AccountUtils";

type Props = {
  bank: Bank;
  productName: string;
  iban: string;
  isDisabled: boolean;
};

export const BankAccountDetailHeader = ({
  bank,
  productName,
  iban,
  isDisabled,
}: Props) => {
  const { t } = useResource();
  const accountNumber = getLocalBankAccountNumberFromIBAN(iban);

  return (
    <Box display="flex" alignItems="center" gap={2}>
      <BankImage
        bank={bank}
        isRounded
        heightOverride={40}
        widthOverride="auto"
        sx={{ opacity: isDisabled ? 0.5 : 1, flexShrink: 0 }}
      />
      <Stack gap={0.25} minWidth={0}>
        <Typography
          fontSize="1rem"
          fontWeight={600}
          sx={{ wordBreak: "break-word" }}
        >
          {t(Resources.BankNames[bank])} · {productName}
        </Typography>
        <Typography fontSize="0.875rem" color="text.secondary">
          {accountNumber}
        </Typography>
      </Stack>
    </Box>
  );
};
